import { config } from 'cfg'

export const NETWORKS_ENDPOINTS = {
  networks: () => `${config.apiBaseUrl}/networks`,
  network: (networkId: number) => `${NETWORKS_ENDPOINTS.networks()}/${networkId}`,
  networkFiles: (networkId: number) => `${NETWORKS_ENDPOINTS.network(networkId)}/files`,
  networkFile: (networkId: number, fileId: number) =>
    `${NETWORKS_ENDPOINTS.networkFiles(networkId)}/${fileId}`,
  networkSegments: (networkId: number) => `${NETWORKS_ENDPOINTS.network(networkId)}/segments`,
  deleteNetworkSegments: (networkId: number) => `${NETWORKS_ENDPOINTS.network(networkId)}/segments`,
  networkLeafSegments: (networkId: number) => `${NETWORKS_ENDPOINTS.network(networkId)}/leaf-segments`
}
